import {IntermediatePart} from "../../intermediatePart";
import {ShowerBodyType} from "../../constants";
import {Shower} from "../../parts/shower";
import {ShowerTubCombo} from "../../parts/showerTubCombo";
import {getFeatureIsLocked} from "../../../../../misc/helpers";
import store from "../../../../../store";
import {toggleNotCompatibleView} from "../../../../../actions/selectionFunctions";

export default class ShowerFloor extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'shower_floor';
    this.translateId = "visualizer.bathroom.shower.shower_floor";
    this.partName = 'Floor';
    this.homePageTitle = 'Shower Flooring';
    this.dbName = 'ShowerFloor';
    this.isStoneFeature = true;
    this.selectedByUser = false;
    this.layerPriority = 6;
  }

  load(dbFeature) {
    return super.load_(dbFeature, new ShowerFloor())
  }

  applyFeatureIfNotCompatible() {
    const parent = this.getParent();
    const shower = parent.getParent();
    shower.showerFloorIsActive = true;
    if (shower.layout && shower.showerTubComboIsActive()) {
      const comboPart = shower.layout.parts[ShowerTubCombo.id];
      comboPart.showerTubComboIsActive = false;
    }
  }

  handleClick(ignoreLocked) {
    super.handleClick(ignoreLocked);
    if (this.notAvailableInVisualizer || getFeatureIsLocked(this)) {
      return
    }
    const parent = this.getParent();
    const shower = parent.getParent();
    if ((!shower.showerFloorIsActive || shower.showerTubComboIsActive()) && !window.location.hash.includes("visualizer")) {
      store.dispatch(toggleNotCompatibleView(true));
      return;
    }

    this.applyFeatureIfNotCompatible();

    this.getParent().selectedByUser = true;
    const threshold = shower.threshold;
    if (threshold && !threshold.selectedByUser) {
      const thresholdAvailableFeatures = threshold.navigationSubItems();
      const currentFloorName = this.getSplittedFeatureName();
      const sameThreshold = thresholdAvailableFeatures.find(tr => tr.part.getSplittedFeatureName() === currentFloorName);
      if (sameThreshold) {
        super.handleClick.call(sameThreshold.part);
        threshold.selectedByUser = false;
      }
    }
  }

  setLayers(layout) {

    if (this.getParent().showerTubComboIsActive()) {
      super.hideLayers();
      return;
    }

    if (this.getParent().customBodyType === ShowerBodyType.Door) {
      const showerDoorParent = this.getParent().showerDoor;
      if (showerDoorParent && showerDoorParent.activeFeature) {
        const currentShowerPanCondition = showerDoorParent.activeFeature.metaData["ShowerPan"];
        if (!currentShowerPanCondition || (currentShowerPanCondition && !currentShowerPanCondition.includes("Threshold"))) {
          super.hideLayers();
          return;
        }
      }
    }

    const conditions = this.getArrayOfConditions();
    if (this.activeFeature && (this.activeFeature.matchesMetaForArrayOfConditions(conditions)
        || (this.activeFeature.notAvailableInVisualizer && this.placeholderFeature))) {
      return super.setLayers(layout);
    }
    this.setDefault();
    return super.setLayers(layout);
  }

  getArrayOfConditions() {
    let conditions = super.getArrayOfConditions(); //roomLayout
    const showerParent = this.getParent();
    conditions.push({
      propName: "ShowerSize",
      propValue: showerParent.showerSize()
    });
    return conditions
  }

  setDefault() {
    const filteredFeatures = this.features.filter(f => f.matchesMetaForArrayOfConditions(this.getArrayOfConditions()));
    if (!super.tryToSetTheSameFeature(filteredFeatures)) {
      const hardCodedDefault = filteredFeatures.find((feature) => {
        return feature.dbFeature.displayName && feature.dbFeature.displayName.includes("Sahara Autumn  Porcelain Tile");
      });
      const placeholderDefault = filteredFeatures.find((feature) => {
        return feature.dbFeature.displayName && feature.dbFeature.displayName.includes("laceholder");
      });
      this.activeFeature = hardCodedDefault || filteredFeatures[0];
      this.placeholderFeature = placeholderDefault || null;
    }
  }

  setZIndex(zIndexes) {
    if (this.getParent().activeSubType() === Shower.Type.Custom) {
      const zIndex = zIndexes.Shower.Floor;
      if (zIndexes && this.activeFeature) {
        this.activeFeature.layer.zIndex = zIndex;
      }
      if (zIndexes && this.placeholderFeature) {
        this.placeholderFeature.layer.zIndex = zIndex;
      }
    }
  }
}
